import { Button } from 'Components/Core';
import { IAgsExportRevision } from 'Data/ViewModels/Ags';
import { buildAgsRevisionDownloadUri } from 'Data/ViewModels/Ags/IAgsExportRevision';
import React from 'react';
import { FaExclamationTriangle, FaFileDownload } from 'react-icons/fa';

interface IAgsFileButton {
  row: IAgsExportRevision;
  onClick: (event?: any) => void;
}

const AgsFileButton: React.FC<IAgsFileButton> = ({ row, onClick }) => {
  return (
    <>
      <Button subtle href={buildAgsRevisionDownloadUri(row.Id)} visible={row.IsContentValid}>
        <FaFileDownload size="20px" />
      </Button>
      <Button className="EquipmentStatus-Icon" subtle error onClick={() => onClick(row)} visible={!row.IsContentValid}>
        <FaExclamationTriangle size="1.5em" />
      </Button>
    </>
  );
};

export { AgsFileButton };
